import React from "react";
import Specification from "./Specification";
const Productdiscription = ({ data }) => {
  return (
    <div>
      <div className="my-10  text-gray-500">
        <div className=" flex flex-col gap-2 lg:leading-loose lg:text-lg md:mb-10 ">
          <h1 className="  text-justify text-xs lg:text-lg   ">
            {data.productDetail.aplusdescription}
          </h1>
          <h1 className=" text-justify">{data.productDetail[1]}</h1>
        </div>

        {/* <h1 className="  text-5xl">product description :</h1> */}
        <img
          className="hidden md:block py-[12px] w-screen object-cover  "
          src={data.productDetail.aPlusContent[0]?.images}
          alt=""
        />
        <img
          className=" md:hidden py-[12px] w-screen object-cover  "
          src={data.productDetail.aPlusContent[0]?.size}
          alt=""
        />
        {/* <h1>{data.productDetail.aPlusContent[0]?.description}</h1> */}

        <div className=" grid sm:grid-cols-3 gap-3 ">
          <div className=" ">
            <img
              className=" w-screen object-cover  "
              src={data.productDetail.aPlusContent[1]?.images}
              alt=""
            />
            <p className="   text-xs lg:text-lg  text-center px-5 py-5">
              {data.productDetail.aPlusContent[2]?.description}
            </p>
          </div>
          <div>
            <img
              className=" w-screen object-cover "
              src={data.productDetail.aPlusContent[2]?.images}
              alt=""
            />
            <p className="  text-xs lg:text-lg  text-center px-5 py-5">
              {data.productDetail.aPlusContent[2]?.description}
            </p>
          </div>
          <div>
            <img
              className=" w-screen object-cover  "
              src={data.productDetail.aPlusContent[3]?.images}
              alt=""
            />
            <p className=" text-xs lg:text-lg text-center px-5 py-5">
              {data.productDetail.aPlusContent[3]?.description}
            </p>
          </div>
        </div>
        <div>
          <img
            className=" hidden md:block w-screen object-cover  "
            src={data.productDetail.aPlusContent[4]?.images}
            alt=""
          />
          <img
            className=" md:hidden w-screen object-cover  "
            src={data.productDetail.aPlusContent[4]?.size}
            alt=""
          />
          <p className="  text-justify py-2 md:py-10 text-xs lg:text-lg">
            {data.productDetail.aPlusContent[4]?.description}
          </p>
        </div>

        <div>
          <img
            className="hidden md:block py-[12px] w-screen object-cover  "
            src={data.productDetail.aPlusContent[5]?.images}
            alt=""
          />
          <img
            className=" md:hidden py-[0px] w-screen object-cover  "
            src={data.productDetail.aPlusContent[5]?.size}
            alt=""
          />
          <p className="  text-justify py-2 md:py-10  text-xs lg:text-lg">
            {data.productDetail.aPlusContent[5]?.description}
          </p>
        </div>
      </div>{" "}
    </div>
  );
};

export default Productdiscription;
